"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerPane = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CloseDialogIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CloseDialogIcon"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const IconTitle_1 = __importDefault(require("@opsbase/web-ui/IconTitle"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    root: {
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        borderRadius: 8,
        minHeight: 400,
        margin: 8,
        boxShadow: `0 0 24px -4px ${lib_palette_1.default.LineGrey.main}`,
    },
    titlePane: {
        borderRadius: '8px 8px 0 0',
        borderBottom: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        backgroundColor: lib_palette_1.default.White.main,
    },
    childPane: {
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        padding: '2px 8px 8px 8px',
    },
});
function InnerPane(props) {
    const { icon, label, children, showDelete, onClickClose, onClickDelete } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.root } },
        react_1.default.createElement(Horizontal_1.default, { shrink: true, centered: true, classes: { root: myCss.titlePane } },
            react_1.default.createElement(Pane_1.default, { padding: true, grow: true },
                react_1.default.createElement(IconTitle_1.default, { icon: icon, title: label })),
            showDelete && (react_1.default.createElement(Button_1.default, { round: true, background: "transparent", color: lib_palette_1.default.BadRed, icon: react_1.default.createElement(DeleteIcon_1.default, null), onClick: onClickDelete })),
            react_1.default.createElement(Button_1.default, { background: "transparent", icon: react_1.default.createElement(CloseDialogIcon_1.default, null), onClick: onClickClose })),
        react_1.default.createElement(Pane_1.default, { grow: true, classes: { root: myCss.childPane } }, children)));
}
exports.InnerPane = InnerPane;
exports.default = InnerPane;
